import {
    TextInput,
    Grid,
    Stack,
    ScrollArea,
    Button,
    Select,
    LoadingOverlay,
  } from "@mantine/core";
  import React, { useEffect } from "react";
  import { useMutation, useQuery } from "@apollo/client";
  import { showNotification } from "@mantine/notifications";
  import { useForm } from "@mantine/form";
  import { useViewportSize } from "@mantine/hooks";
  import { GET_ALL_SUPPLIERS, GET_SUPPLIERS_PAYOUTS } from "apollo/queries";
  import { customLoader } from "components/utilities/loader";

import { useState } from "react";
import { UPDATE_SUPPLIER_PAYOUT } from "apollo/mutuations";
  
  const SupplierUpdatePayout = ({ setOpenedEdit, supplierPayout }) => {
    const [suppliers, setSuppliers] = useState([]);
    const form = useForm({
      initialValues: {
        supplier_id: "",
        amount: "",
        reference: "",
        payment_method: "",
      },
      validate: {
        supplier_id: (value) => (!value ? "Supplier is required" : null),
        amount: (value) => {
          if (!value) return "Amount is required";
          if (isNaN(value) || parseFloat(value) <= 0)
            return "Amount must be a positive number";
          return null;
        },
        reference: (value) => (!value ? "Reference is required" : null),
        payment_method: (value) => (!value ? "Payment method is required" : null),
      },
    });
  
    useEffect(() => {
      if (supplierPayout) {
        form.setValues({
          supplier_id: supplierPayout.supplier?.id || "",
          amount: supplierPayout.amount?.toString() || "",
          reference: supplierPayout.reference || "",
          payment_method: supplierPayout.payment_method || "",
        });
      }
    }, [supplierPayout]);
  
    const { data, loading, refetch } = useQuery(GET_ALL_SUPPLIERS, {
      variables: {
        first: parseInt(2000),
        page: 1,
        search: "",
        ordered_by: [
          {
            column: "CREATED_AT",
            order: "DESC",
          }
        ]
        },
      onCompleted(data) {
        const arr = data.getSuppliers.data.map((item) => ({
          label: item.user.name,
          value: item.id,
        }));
        setSuppliers(arr);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Get Suppliers",
        });
      },
    });
  
    const [updateSupplierPayout, { loading: payoutLoading }] = useMutation(
      UPDATE_SUPPLIER_PAYOUT,
      {}
    );
  
    const { height } = useViewportSize();
    const submit = () => {
      if (form.validate().hasErrors) return;
  
      const variables = {
        id: supplierPayout.id,
        supplier_id: form.getInputProps("supplier_id").value,
        amount: parseFloat(form.getInputProps("amount").value),
        reference: form.getInputProps("reference").value,
        payment_method: form.getInputProps("payment_method").value,
      };
  
      updateSupplierPayout({
        variables,
        onCompleted() {
          showNotification({
            color: "green",
            title: "Success",
            message: "Payout Updated Successfully",
          });
          setOpenedEdit(false);
        },
        onError(error) {
          showNotification({
            color: "red",
            title: "Error",
            message:
              error?.graphQLErrors?.[0]?.message || "Failed to update payout",
          });
          setOpenedEdit(false);
        },
      });
    };
  
    const handleSupplierChange = (val) => {
      form.setFieldValue("supplier_id", val);
    };
  
    useEffect(() => {
      refetch();
    }, []);
  
    return (
      <>
        <LoadingOverlay
          visible={loading || payoutLoading}
          color="blue"
          overlayBlur={2}
          loader={customLoader}
        />
        <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
          <form onSubmit={form.onSubmit(() => submit())}>
            <Stack>
              <Grid>
                <Grid.Col span={6}>
                  <Select
                    searchable
                    required
                    data={suppliers}
                    value={form.getInputProps("supplier_id").value}
                    onChange={handleSupplierChange}
                    label="Supplier"
                    placeholder="Pick a supplier"
                    error={form.errors.supplier_id}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    required
                    type="number"
                    label="Amount"
                    placeholder="Enter amount"
                    {...form.getInputProps("amount")}
                    error={form.errors.amount}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    required
                    label="Reference"
                    placeholder="Enter reference"
                    {...form.getInputProps("reference")}
                    error={form.errors.reference}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    required
                    label="Payment Method"
                    placeholder="Enter payment method"
                    {...form.getInputProps("payment_method")}
                    error={form.errors.payment_method}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={12}>
                  <Button
                    style={{
                      width: "20%",
                      backgroundColor: "#FF6A00",
                      color: "#FFFFFF",
                    }}
                    type="submit"
                  >
                    Submit
                  </Button>
                </Grid.Col>
              </Grid>
            </Stack>
          </form>
        </ScrollArea>
      </>
    );
  };
  
  export default SupplierUpdatePayout;